import React from "react";
import Typography from '@mui/material/Typography';
import {makeStyles} from '@mui/styles';
import {globalTheme} from "../components/Theme";

const useStyles = makeStyles((theme) => ({
    root:{
        position: "relative",
    },
    header:{
        fontWeight: 600,
        padding: theme.spacing(3)
    },
    resumeFile: {
        flexGrow: 1,

    },
    resume: {
        width: "80%",
        marginLeft: "10%",
        marginBottom: "10%",
        display: "flex",
        flexDirection: "column",
        justify: "center",
        alignItems: "center",
        [theme.breakpoints.down('lg')]: {
            height: "720px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "400px",
        },
        [theme.breakpoints.up('md')]: {
            height: "90vh"
        }
    },
    downloadBtn: {
        position: "relative",
        bottom: "75px",
    },
    downloadImg: {
        fontSize: "50px",
    },
}));

export default function Resume(){
    const classes= useStyles();

    return(
        <div className= {classes.root + " resume-content"}>

            <Typography variant="h2" align="center" style={globalTheme.palette.heading} className={classes.header}>
                Resume
            </Typography>
            
            <div className={classes.resume}>
                <iframe 
                    title="timothy-tan-resume"
                    src="https://drive.google.com/file/d/1ORVgmTaP7KWBEUahBmqQTJZVBhT01WcL/preview"
                    width="100%" height="100%" className={classes.resumeFile}>

                </iframe>
            </div>
        </div>
    );
}